import app from '../../admin/app';
import Component from '../../common/Component';
import Icon from '../../common/components/Icon';
import Link from '../../common/components/Link';
import dayjs from 'dayjs';
export default class AnnouncementItem extends Component {
  view() {
    var _a$authorName;
    const a = this.attrs.announcement;
    const date = dayjs(a.createdAt).format('MMM D, YYYY');
    return m(Link, {
      className: "AnnouncementItem",
      href: a.url,
      external: true,
      target: "_blank"
    }, m("div", {
      className: "AnnouncementItem-body"
    }, m("h3", {
      className: "AnnouncementItem-title"
    }, a.isSticky && m(Icon, {
      name: "fas fa-thumbtack",
      className: "AnnouncementItem-stickyIcon"
    }), a.title), a.excerpt && m("p", {
      className: "AnnouncementItem-excerpt"
    }, a.excerpt)), m("div", {
      className: "AnnouncementItem-footer"
    }, m("div", {
      className: "AnnouncementItem-byline"
    }, a.avatarUrl ? m("img", {
      className: "AnnouncementItem-avatar",
      src: a.avatarUrl,
      alt: (_a$authorName = a.authorName) != null ? _a$authorName : '',
      loading: "lazy"
    }) : m("span", {
      className: "AnnouncementItem-avatarFallback"
    }, m(Icon, {
      name: "fas fa-user"
    })), m("div", {
      className: "AnnouncementItem-bylineText"
    }, a.authorName && m("span", {
      className: "AnnouncementItem-authorName"
    }, a.authorName), m("span", {
      className: "AnnouncementItem-meta"
    }, m("span", {
      className: "AnnouncementItem-date"
    }, date), m("span", {
      className: "AnnouncementItem-sep"
    }, "\xB7"), m("span", {
      className: "AnnouncementItem-comments"
    }, m(Icon, {
      name: "fas fa-comment-alt"
    }), app.translator.trans('core.admin.announcements.comments_label', {
      count: a.commentCount
    }))))), m("div", {
      className: "AnnouncementItem-readMore"
    }, app.translator.trans('core.admin.announcements.read_more'), m(Icon, {
      name: "fas fa-arrow-right"
    }))));
  }
}
flarum.reg.add('core', 'admin/components/AnnouncementItem', AnnouncementItem);